import { FC } from 'react';

import { useBreakpoint } from '@hh.ru/magritte-ui';

import { NOTIFICATION_CONFIG } from 'components/MagritteNotifications/config';
import Notification from 'components/MagritteNotifications/Notification/Notification';

import { deleteMagritteCustomNotification, deleteMagritteNotification } from 'store/models/notification';
import { useDispatch, useSelector } from 'store/utils';

import 'components/Notifications/ClickmeManager/ClickmeManager.less';

export const MagritteNotifications: FC = () => {
    const notifications = useSelector((state) => state.notification.magritteNotifications);
    const customNotifications = useSelector((state) => state.notification.magritteCustomNotifications);
    const dispatch = useDispatch();
    const { isMobile } = useBreakpoint();

    return (
        <>
            {notifications.map(({ name, id }, index) => {
                const config = NOTIFICATION_CONFIG[name];
                if (!config) {
                    return null;
                }
                const { trl: trlNotification, ...restProps } = config;
                return (
                    <Notification
                        key={id}
                        onClose={() => {
                            dispatch(deleteMagritteNotification(index));
                        }}
                        trlNotification={trlNotification}
                        align={isMobile ? 'top' : 'bottom'}
                        {...restProps}
                    />
                );
            })}
            {customNotifications.map(({ notification, id }, index) => {
                const { trl: trlNotification, ...restProps } = notification;
                return (
                    <Notification
                        key={id}
                        onClose={() => {
                            dispatch(deleteMagritteCustomNotification(index));
                        }}
                        trlNotification={trlNotification}
                        align={isMobile ? 'top' : 'bottom'}
                        {...restProps}
                    />
                );
            })}
        </>
    );
};
